import { __decorate } from "tslib";
import { Component, Prop, Vue } from "../../../vue";
import styles from "./JsonTree.module.css";
let JsonTree = class JsonTree extends Vue {
  get treeData() {
    const result = {
      key: '0',
      title: {
        key: '',
        value: this.jsonData
      }
    };
    iterateObject(this.jsonData, result, (key, value, current) => {
      if (!current.children) {
        current.children = [];
      }
      const child = {
        title: {
          key,
          value
        },
        key: `${current.key}-${current.children.length}`
      };
      current.children.push(child);
      return child;
    });
    return [result];
  }
  render() {
    const h = arguments[0];
    return h("a-tree", [this.renderTreeNode(this.treeData)]);
  }
  renderTreeNode(treeData) {
    const h = this.$createElement;
    if (!treeData || !treeData.length) return '';
    return treeData.map(treeNode => h("a-tree-node", {
      "attrs": {
        "selectable": false
      },
      "class": styles.jsonTree,
      "key": treeNode.key
    }, [this.renderTreeNode(treeNode.children), this.renderTreeNodeTitle(treeNode.title)]));
  }
  renderTreeNodeTitle(title) {
    const h = this.$createElement;
    return h("p", {
      "class": typeof title.value === 'string' ? styles.jsonTreeTitleStr : styles.jsonTreeTitle,
      "slot": "title"
    }, [this.renderTitleKey(title.key), this.renderTitleValue(title.value)]);
  }
  renderTitleKey(key) {
    const h = this.$createElement;
    return key ? h("span", {
      "class": "ant-timeline-item-head-blue"
    }, [key, ": "]) : '';
  }
  renderTitleValue(value) {
    const h = this.$createElement;
    let valueStr = '';
    let extraJsonStr = '';
    if (typeof value === 'object') {
      valueStr = Object.prototype.toString.call(value).replace(/\[object\s(\w+)\]/, '$1');
      extraJsonStr = JSON.stringify(value, (k, v) => {
        if (!k) {
          return v;
        }
        const typeofV = Object.prototype.toString.call(v).replace(/\[object\s(\w+)\]/, '$1');
        if (typeofV === 'Object') {
          return '{...}';
        }
        if (typeofV === 'Array') {
          return '[...]';
        }
        return v;
      });
    } else {
      valueStr = `${JSON.stringify(value)}`;
    }
    return h("span", [valueStr, h("span", {
      "class": "json_title_extra"
    }, [` ${extraJsonStr}`])]);
  }
};
__decorate([Prop()], JsonTree.prototype, "jsonData", void 0);
JsonTree = __decorate([Component], JsonTree);
export default JsonTree;
function iterateObject(obj, res, handler) {
  const keys = Object.keys(obj);
  keys.forEach(key => {
    if (!obj[key]) {
      return handler(key, obj[key], res);
    }
    if (typeof obj[key] === 'object') {
      const child = handler(key, obj[key], res);
      iterateObject(obj[key], child, handler);
    } else {
      handler(key, obj[key], res);
    }
  });
}
//# sourceMappingURL=JsonTree.js.map
